import { Inline, Spinner, styled } from '@lessonnine/design-system.lib'
// External Imports
import React from 'react'

// Styled Components
const Container = styled(Inline)`
  height: 100vh;
  background-color: #f6f4ef;
`

// Component Definition
export function LoadingContent() {
  return (
    <Container align="center" alignItems="center">
      <Spinner size="xxlarge" />
    </Container>
  )
}
